/**
 * Version identity for the running bundle.
 *
 * The full string is `major.minor.patch.buildnumber`, for example `1.0.4.202608191520`.
 *
 * - `major` and `minor` are moved by hand, by the owner, when a release deserves it.
 * - `patch` is bumped automatically by `scripts/bump-version.mjs`, which deploy-ovh.sh runs once
 *   per release. It is not bumped by `vite build`, because the gate builds too.
 * - `buildnumber` is the build stamp, local time, YYYYMMDDHHMM. It changes on every build and is
 *   what actually detects a stale tab.
 *
 * Vite replaces both constants at build time. See vite.config.ts.
 */
export const APP_VERSION: string = __APP_VERSION__
export const BUILD_ID: string = __BUILD_ID__

/** What a person reads out over the phone: `1.0.4.202608191520`. */
export const FULL_VERSION = `${APP_VERSION}.${BUILD_ID}`

/** `202608191520` reads as `2026-08-19 15:20`. */
export function formatBuildId(id: string): string {
  if (!/^\d{12}$/.test(id)) return id
  return `${id.slice(0, 4)}-${id.slice(4, 6)}-${id.slice(6, 8)} ${id.slice(8, 10)}:${id.slice(10, 12)}`
}
